import { storageGet, storageSet } from '../platform/storage';

export const LOCATION_CACHE_KEY = 'v2_location';

export async function readLocationCache() {
  return storageGet(LOCATION_CACHE_KEY);
}

/**
 * Shallow-merge into v2_location. Pass `null` for a key to remove it.
 */
export async function mergeLocationBlob(partial) {
  const existing = (await readLocationCache()) || {};
  const next = { ...existing };
  delete next.storeSelection;
  delete next.cachedAt;

  for (const [k, v] of Object.entries(partial)) {
    if (v === undefined) continue;
    if (v === null) delete next[k];
    else next[k] = v;
  }

  await storageSet(LOCATION_CACHE_KEY, next);
  return next;
}

export async function writeLocationCache(blob) {
  const next = { ...blob };
  delete next.cachedAt;
  await storageSet(LOCATION_CACHE_KEY, next);
  return next;
}

/** Remove assigned store (e.g. current GPS is outside delivery radius). */
export async function clearAssignedStoreFromCache(extra = {}) {
  return mergeLocationBlob({
    storeId: null,
    storeName: null,
    podId: null,
    store: null,
    ...extra,
  });
}
